<template>
    <div>
        <a v-if="picker" class="picker" @click="openPopup">
            {{
        this.$store.state.productInfo.sizes
          .find((s) => s.sizeId == this.$store.state.userProduct.sizeId )
          .sizeName.replace(" Inch", "")
            }}
        </a>
        <div v-bind:class="[picker ? 'popup' : '']" v-if="active">
            <div class="popup-content">
                <div class="sizes popup-scroll">



                    <div ref="carousel">
                        <div class="size "><div> Select Size </div></div>
                        <div v-for="(s, index) in sortedSizes"
                             :data-index="index"
                             :data-sizeId="s.sizeId"
                             :key="s.sizeId"
                             v-on:click="setSize(s.sizeId, index)"
                             v-bind:class="[
                'size',
                { selected: s.sizeId == userProduct.sizeId },
              ]"
                             :ref="'size-' + s.sizeId">
                            <div :title="'For ' + (s.sizeName.replace(' Inch', '') - 3) + ' Pant Size'" v-if="productInfo.productName=='Belt'">
                                {{ s.sizeName.replace(" Inch", "") + ' (Fits ' + (s.sizeName.replace(' Inch', '') - 3) + ' Pant Size)' }}
                            </div>
                            <div v-else>
                                {{ s.sizeName.replace(" Inch", "") }}
                            </div>
                        </div>
                    </div>

                    <!--<select id="sizeSelect" v-on:change="setSize(parseInt($event.target.value), parseInt($event.target.dataIndex))">
                <option value="0">hello</option>
                <option v-for="(s, index) in sortedSizes"
                        :key="s.sizeId"
                        :value="s.sizeId"
                        :data-index="index">
                    {{s.sizeName}}
                </option>
            </select>-->


                </div>

                <div class="info-box popup-static" v-if="productInfo.productName=='Belt'">
                    <!--<h2>Belt Sizing Info</h2>-->

                    <img src="https://assets.needlepaint.com/images/custom-needlepoint-belt-sizing.png"
                         width="100%"
                         alt="Custom Needlepoint Belt Sizing" />
                    <p>
                        Your pant size is not your belt size! <strong>We recommend ordering the belt 3 inches larger than the pant size.</strong>
                        Please note that when measuring an existing belt, you should
                        measure from the base of the prong to the most worn hole.
                    </p>
                </div>

                <div class="info-box popup-static" v-if="productInfo.productName=='Dog Collar'">
                    <h2>Dog Collar Sizing Info</h2>

                    <img src="https://assets.needlepaint.com/images/custom-needlepoint-dog-collar-sizing.png"
                         width="100%"
                         alt="Custom Needlepoint Dog Collar Sizing" />
                    <p>
                        Your design is made specific to your dog's collar size. It is important that you have the right size,
                        so make sure to measure an existing collar to ensure you are getting the right fit.
                        Please note that when measuring an existing collar with a clip, you should go from the solid end to where the prongs start on the other side.
                    </p>
                </div>

            </div>

            <div class="overlay stop" v-if="!modify"></div>
            <div class="overlay" v-on:click="active = false"></div>
        </div>
    </div>
</template>

<script>
    import Globals from "@/globals.js";

    import { mapState } from "vuex";

    export default {
        name: "ProductSizes",
        data() {
            return {
                active: this.isOpen,
                picker: this.isPicker,
                modify: Globals.isModProduct(),
            };
        },
        props: {
            isOpen: Boolean,
            isPicker: Boolean,
        },
        methods: {
            setSize(sId, index) {
                console.log(sId);
                if (this.checkWidth(sId)) {
                    this.$store.dispatch("setUserProductSize", sId);
                    //let index = this.$refs["size-" + sId].getAttribute("data-index");
                    //this.$refs.carousel.goTo(index);
                    if (this.picker) this.active = false;
                    if (this.$route.name == "Size") {
                        this.setLoading().then(value => {
                            //console.log('then');
                            this.$router.push('motifs');
                            //console.log(value);
                        });
                    } //this.$router.push({ path: "/motifs/" });

                    this.modify = true;
                }
            },
            setLoading() {
                return new Promise((resolve, reject) => {
                    let x = this.$store.dispatch("setLoadingStatus", "Loading");
                    setTimeout(() => {
                        return (x) ? resolve(this.$store.state.loadingStatus) : reject('error');
                    }, 200);
                });
            },
            checkWidth(sId) {
                //console.log('modify:' + this.modify);
                if ((!this.modify) && (Globals.getFinishStep() != 3)) {
                    console.log("about to checkWidth");
                    Globals.checkWidth(this.$store, sId, null, 0, false);
                    return true;
                }
                let hasSpace = Globals.checkWidth(this.$store, sId, null, 0);
                //console.log('hasSpace: ' + hasSpace);
                if (hasSpace) {
                    return true;
                } else {
                    this.$emit("alert-width", null);
                    return false;
                }
            },
            openPopup: function () {
                this.active = true;
                console.log('product size openPopup');
                this.$nextTick(() => {
                    let initialSizeId = this.userProduct.sizeId;
                    console.log(initialSizeId);
                    console.log(this.$refs["size-" + initialSizeId]);
                    //let initialIndex =
                    //    this.$refs["size-" + initialSizeId].getAttribute("data-index");
                    //this.$refs.carousel.goTo(initialIndex);

                    //this.$refs["size-" + initialSizeId].scrollIntoView({ behavior: 'smooth' });
                    if (!this.modify) {
                        document.querySelector('.sizes .size.selected').classList.remove('selected');
                    } else
                    document.querySelector(".sizes .size.selected").scrollIntoView();


                });
            },
        },

        computed: {
            ...mapState(["productInfo", "userProduct"]),

            sortedSizes() {
                let sorted = this.productInfo.sizes
                    .slice(0)
                    .sort((s1, s2) => s1.sizeWidth - s2.sizeWidth);
                return sorted;
            },
            
        },

        mounted: function () {
            console.log("productsizes mounted");
            if (Globals.isModProduct() != 1) {
                // Skip the destructive mount-time fit check when an origin kit
                // is loaded ("Personalize Now" flow). Motifs from a saved kit
                // were already validated when the kit was created, but the
                // load-time spacing math (stitchMotifMinSpacingLoad/2 = 6) is
                // stricter than save-time, so a kit with 3 motifs that fit
                // when saved would silently drop one on personalize.
                if (Globals.getProductType() == 7 && Globals.okitId() == 0) {
                    this.checkWidth(this.userProduct.sizeId);
                }
                this.openPopup();
            }
        },
        //components: { VueSlickCarousel },
    };
</script>
<style>
    .sizes {
        padding: 1em;
    }

        .sizes .size {
            padding: 0.1em;
            line-height: 1.5em;
            cursor: pointer;
            border-radius: 2px;
            position: relative;
            margin: 3px 0;
        }

            .sizes .size:first-child {
                background: #eee;
                cursor: auto;
            }
    /*.size[data-index="0"]::before {
        content: "";*/
        /*! background: linear-gradient(to right, #ccc 0%, #fff); */
        /*! height: 100%; */
        /*width: 80px;
        position: absolute;*/
        /*! transform: translate(-1.25em, 0); */
        /*z-index: -1;
        left: -3px;
        top: -3px;
        bottom: -3px;
        border: dotted 1px #666;
        border-right: none;
        mask-image: linear-gradient(to right, black 0%, transparent 100%);
        -webkit-mask-image: linear-gradient(to right, black 0%, transparent 100%);
    }

    .size[data-index="0"]::after {
        content: "";*/
        /*! height: 100%; */
        /*width: 80px;
        position: absolute;
        z-index: -1;
        right: calc(100% + 9px );
        top: -3px;
        bottom: -3px;
        border: dotted 1px #666;
        border-left: none;
        mask-image: linear-gradient(to left, black 0%, transparent 100%);
        -webkit-mask-image: linear-gradient(to left, black 0%, transparent 100%);
    }*/

    .sizes .size:hover {
        background: #ccc;
    }

    .sizes .size.selected {
        font-weight: bold;
        color: #fff;
        background: #666;
    }

    .sizes button.slick-arrow {
        top: calc(50%);
    }

    .sizes .step-static {
        padding-bottom: 2em;
    }

    .popup .sizes .slick-slider {
        margin-bottom: 2em;
    }


    .sizes .size:first-child {
        background: #eee;
        cursor: auto;
    }

   

   
    
    
</style>
